export default __webpack_public_path__ + "static/media/ic_delivery_white.55ffacd8.svg";